import FableAudits from '../components/atu2fable/FableAudits';
import FableBlockers from '../components/atu2fable/FableBlockers';
import FableEvidence from '../components/atu2fable/FableEvidence';
import FableJourney from '../components/atu2fable/FableJourney';
import FableNextAction from '../components/atu2fable/FableNextAction';
import FableOpsAutomation from '../components/atu2fable/FableOpsAutomation';
import FableRuns from '../components/atu2fable/FableRuns';
import FableSafetyChecklist from '../components/atu2fable/FableSafetyChecklist';
import FableVerdict from '../components/atu2fable/FableVerdict';
import DailyTacticalReportVisibility from '../components/atu2/DailyTacticalReportVisibility';
import Atu2ViewSwitch from '../components/atu2/Atu2ViewSwitch';
import { useFableLab } from '../hooks/useFableLab';
import './Atu2LabFable.css';

/**
 * ATU2 2.0 운영 판단 화면 (read-only).
 */
export default function Atu2LabFable() {
  const {
    readiness, summary, market, audit, opsAutomation, reportHistory, proposals,
    loading, refreshedAt, reload,
  } = useFableLab();
  const r = readiness.data;

  return (
    <div className="fable-lab-page">
      <header className="fable-lab-header">
        <div>
          <span className="fable-kicker">ATU2 2.0</span>
          <h1>오늘의 운영 판단</h1>
          <p>현재 상태, 돈의 안전, 남은 문제와 필요한 결정을 순서대로 보여줍니다.</p>
        </div>
        <div className="fable-header-side">
          <button className="fable-refresh" onClick={reload} disabled={loading}>
            {loading ? '갱신 중...' : '새로고침'}
          </button>
          <span>{refreshedAt ? `${refreshedAt.toLocaleTimeString('ko-KR')} 갱신` : '갱신 대기'}</span>
        </div>
      </header>

      <Atu2ViewSwitch current="decision" />

      {loading && !r && <div className="fable-panel fable-empty">2.0 검증 상태 로딩 중...</div>}
      {readiness.error && (
        <div className="fable-panel fable-error">API 오류: {readiness.error}</div>
      )}

      <FableVerdict readiness={r} market={market.data} opsAutomation={opsAutomation.data} />

      {market.error && (
        <div className="fable-panel fable-error">API 오류: 시장 상태 — {market.error}</div>
      )}

      {r && (
        <>
          <FableNextAction readiness={r} market={market.data} opsAutomation={opsAutomation.data} />
          <FableSafetyChecklist readiness={r} />
          <FableBlockers readiness={r} />
          <FableJourney readiness={r} />
          <FableEvidence readiness={r} />
          <FableOpsAutomation data={opsAutomation.data} error={opsAutomation.error} />
          <DailyTacticalReportVisibility
            history={reportHistory.data}
            proposals={proposals.data}
            historyError={reportHistory.error}
            proposalsError={proposals.error}
            variant="fable"
          />
          <FableAudits readiness={r} audit={audit.data} auditError={audit.error} />
          <FableRuns readiness={r} summary={summary.data} summaryError={summary.error} />
        </>
      )}

      <footer className="fable-footer">
        이 화면에서는 조회만 할 수 있습니다. 실행, 주문, 설정 변경은 할 수 없습니다.
        영문 식별자와 원본값은 상단의 ‘기술 상세’에서 확인할 수 있습니다.
      </footer>
    </div>
  );
}
